<template>
  <!-- 车辆管理 -->
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class=" inpBox">
               <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
              </el-form-item>
                <el-form-item label="车牌颜色:" prop="noColourId">
                <el-select placeholder="请选择" v-model="searchFrom.noColourId">
                  <el-option
                    v-for="item in clys"
                    :key="item.id"
                    :label="item.colourName"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆类型:" prop="vhcTypeId" >
                <el-select placeholder="请选择" v-model="searchFrom.vhcTypeId">
                  <el-option
                    v-for="item in vehicleT"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="所属单位/个人:" prop="vehicleTenantName">
                <el-input  placeholder="" v-model="searchFrom.vehicleTenantName"></el-input>
              </el-form-item>
              <el-form-item label="行驶证号:" prop="drivingLicense">
                <el-input  placeholder="" v-model="searchFrom.drivingLicense"></el-input>
              </el-form-item>
               <el-form-item label="能源类型:" prop="energyId">
                <el-select placeholder="请选择" v-model="searchFrom.energyId">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.id"
                    :label="item.energyName"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="排放标准:" prop="standardsId">
                <el-select placeholder="请选择" v-model="searchFrom.standardsId">
                  <el-option
                    v-for="item in pfbz"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="载重(吨):" prop="weight">
                <el-input  placeholder="" v-model="searchFrom.weight"></el-input>
              </el-form-item>
                  <el-form-item label="审核状态:" prop="auditStatus">
                <el-select placeholder="全部" v-model="searchFrom.auditStatus">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="待审核" value="1" ></el-option>
                  <el-option  label="审核通过" value="2" ></el-option>
                  <el-option  label="审核驳回" value="3" ></el-option>
                </el-select>
            </el-form-item>
               <el-form-item label="创建时间:" prop="createTime">
                    <el-date-picker
                      v-model="searchFrom.createTimes"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
       </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="00IP002B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[4]">
            <el-button type="primary"  @click="addVeicle">新增</el-button>
          </el-form-item>
           <el-form-item  v-if="btnFlg[1]">
            <el-button type="primary" @click="guanlianFn">关联车辆</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <div>
                     <el-button type="text" size="mini"   v-if="scope.row.tenantId == tenantCode&&btnFlg[2]&&scope.row.auditStatus!=2"  @click="modifyVeicle(scope.row)">修改</el-button>
                  <el-button type="text" size="mini"  v-if="btnFlg[0]" v-show="scope.row.tenantId==tenantCode" @click="lookImg(scope.row)">查看</el-button>
                  <el-button type="text" size="mini"   v-if="btnFlg[3]" @click="Unconnect(scope.row)">删除</el-button>
                  </div>
                </template>
        </el-table-column>
        <el-table-column property="auditStatus" label="审核状态"  width="120">
          <template scope="scope">
            {{[ "待审核", "审核通过", "审核驳回" ][scope.row.auditStatus-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="vhcNo"  width="100" :formatter="emptyFn" label="车牌号"></el-table-column>
       <el-table-column prop="noColourName" width="100"  :show-overflow-tooltip="true" :formatter="emptyFn" label="车牌颜色"></el-table-column>
        <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" :formatter="emptyFn" label="车辆类型"></el-table-column>
          <!-- <el-table-column property="vhcClassify" label="车辆所属" >
          <template scope="scope">
            {{scope.row.tenantId!=tenantCode?'市场车辆':'自家车辆'}}
          </template>
        </el-table-column> -->
        <el-table-column property="vehicleTenantName" min-width="260"  :show-overflow-tooltip="true" :formatter="emptyFn" label="所属单位/个人" > </el-table-column>
        <el-table-column property="drivingLicense"   width="200"  :show-overflow-tooltip="true" label="行驶证号">
          <template scope="scope">
            <div>
           <p v-if="scope.row.tenantId!=tenantCode">
            {{scope.row.drivingLicense.replace(/^(.{4})(?:\d+)(.{4})$/, "$1****$2")}}
          </p>
          <p v-else>{{scope.row.drivingLicense}}</p>
          </div>
          </template>
        </el-table-column>
        <el-table-column prop="energyName" width="100"  :show-overflow-tooltip="true" :formatter="emptyFn" label="能源类型"></el-table-column>
        <el-table-column prop="standardsName" width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="排放标准"></el-table-column>
        <el-table-column prop="weight" width="100"  :show-overflow-tooltip="true" :formatter="emptyFn" label="载重(吨)"></el-table-column>
         <!-- <el-table-column prop="nopassReason" min-width="260" :formatter="emptyFn"  :show-overflow-tooltip="true"  label="驳回原因"></el-table-column> -->
          <el-table-column prop="nopassReason" min-width="260" :show-overflow-tooltip="true"  label="驳回原因">
                  <template scope="scope">
                    <div>
                      {{scope.row.auditStatus == 3 ? scope.row.nopassReason : '-'}}
                    </div>
                  </template>
                </el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 查看 -->
    <el-dialog title="查看详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="lookImgVisible" @close="closeDialog" width="1120px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
               <el-form-item label="车牌号:" prop="addFrom">
                 <span>{{addFrom.vhcNo}}</span>
              </el-form-item>
              <el-form-item label="车牌颜色:" prop="vhcNoColour">
               <span>{{addFrom.noColourName}}</span>
             </el-form-item>
              <el-form-item label="车辆类型:" class="is-required"  prop="vhcType">
                 <span>{{addFrom.vhcTypeName}}</span>
             </el-form-item>
               <el-form-item label="能源类型:"  prop="energyType">
                 <span>{{addFrom.energyName}}</span>
             </el-form-item>
             <el-form-item label="车辆所属:" class="is-required"   prop="vhcClassify">
                <span>{{addFrom.vhcClassify==1?'单位':'个人'}}</span>
             </el-form-item>
             <el-form-item label="所属单位/个人:" prop="vehicleTenantName" >
              <span>{{addFrom.vehicleTenantName}}</span>
              </el-form-item>

             <el-form-item label="使用性质:"  prop="purpose">
               <span>{{addFrom.purposeName}}</span>
             </el-form-item>
             <el-form-item label="排放标准:"  prop="standards">
                <span>{{addFrom.standardsName}}</span>
             </el-form-item>
              <el-form-item label="行驶证号:" prop="drivingLicense">
                 <span>{{addFrom.drivingLicense}}</span>
              </el-form-item>
              <el-form-item label="总质量(吨):" prop="vhcQuality">
                 <span>{{addFrom.vhcQuality}}</span>
              </el-form-item>
              <el-form-item label="载重(吨):" prop="weight">
                 <span>{{addFrom.weight}}</span>
              </el-form-item>
              <el-form-item label="外廓尺寸(米):" prop="">
               <span>{{addFrom.vhcLongName}}</span>
              </el-form-item>
              <el-form-item label="车架号:" prop="vhcVinNo">
                <span>{{addFrom.vhcVinNo}}</span>
              </el-form-item>
               <el-form-item label="发动机号:"  prop="vhcEngineNo">
                 <span>{{addFrom.vhcEngineNo}}</span>
              </el-form-item>
              <el-form-item label="道路运输证号:"  prop="transportNo">
                <span>{{addFrom.transportNo}}</span>
              </el-form-item>

              <el-form-item label="发证机关:"  prop="issueAuthority">
                <span>{{addFrom.issueAuthority}}</span>
              </el-form-item>
              <el-form-item label="发证日期:" prop="issueDate">
                <el-date-picker
                  v-model="addFrom.issueDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                    placeholder="选择日期时间"
                     :readonly="true"
                ></el-date-picker>
                </el-form-item>
              <el-form-item label="注册日期:" prop="registerDate">
                <el-date-picker
                  v-model="addFrom.registerDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                    placeholder="选择日期时间"
                     :readonly="true"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="道路运输经营许可证号:"  prop="businessLicenseNo" label-width="140">
                 <span>{{addFrom.businessLicenseNo}}</span>
              </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>证件信息</span>
              </h4>
            </div>
            <div class="box">
              <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcLicense1Url"
                      :preview-src-list="[addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.transportPhotoUrl,addFrom.vhcPhoto1Url]">
                    </el-image>
                    <h6>行驶证(正页)</h6>
                </div>
                <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcLicense2Url"
                      :preview-src-list="[addFrom.vhcLicense2Url,addFrom.transportPhotoUrl,addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url]">
                    </el-image>
                    <h6>行驶证(副页)</h6>
                </div>
                <div class="imgBox">
                   <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.transportPhotoUrl"
                      :preview-src-list="[addFrom.transportPhotoUrl,addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,]">
                    </el-image>
                    <h6>道路运输证</h6>
                </div>
                <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcPhoto1Url"
                      :preview-src-list="[addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.transportPhotoUrl]">
                    </el-image>
                    <h6>车头照片</h6>
                </div>
            </div>
            <!-- <div class="addressBox" v-if="addFrom.vhcClassify==1">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>挂靠声明</span>
              </h4>
            </div>
            <div class="imgBox" v-if="addFrom.vhcClassify==1">
              <el-image
                  style="width: 320px; height: 200px"
                  :src="addFrom.guaKaoUrl"
                    :preview-src-list="[addFrom.guaKaoUrl]">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div> -->
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookImgVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 关联che -->
    <guanlianche v-if="guanlianFlag" :guanlianFlag.sync="guanlianFlag"></guanlianche>
    <!-- 新建、修改车辆 -->
    <addVehicle :isAdd='isAdd' :row-data="row" v-if="dialogVisible"   @destroy="destroy"></addVehicle>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { fleetVehicleList, cVLlist, cVTlist, cVPlist,
  cVElist, cVhcEnergyTypeList, cVhcNoColourList, getStatementByVchId, fleetDelVehicle } from '@/api/vgs-driver2.0'
import guanlianche from '@/views/vgs-driver2.0/zujian/guanlianche.vue'
import addVehicle from '@/views/vgs-driver2.0/zujian/addVehicle.vue'
export default {
  components: {
    guanlianche,
    addVehicle
  },
  data () {
    return {
      tenantCode: '', // 为判断是否是自家车辆
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      total: 0,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addFrom: {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        guaKaoUrl: ''
      },
      importDialog: false,
      isAdd: true,
      title: '添加',
      vehicleL: [],
      vehicleT: [],
      clyt: [],
      pfbz: [],
      vhcType: {},
      vhcL: {},
      ids: [],
      rules: {
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        noColour: [
          { required: true, message: '请选择车牌颜色', trigger: ['blur', 'change'] }
        ],
        vhcCompany: [
          { required: true, message: '请输入所属单位', trigger: 'blur' }
        ],
        vhcCompany1: [
          { required: true, message: '请输入所属个人', trigger: 'blur' }
        ],
        vhcType: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
        vhcClassify1: [{ required: true, message: '请选择车辆所属', trigger: ['blur', 'change'] },
          { validator: this.rule.isVhcClassify, trigger: 'blur' }],
        energy: [{ required: true, message: '请选择能源类型', trigger: ['blur', 'change'] }],
        purpose: [{ required: true, message: '请选择使用性质', trigger: ['blur', 'change'] }],
        standards: [{ required: true, message: '请选择排放标准', trigger: ['blur', 'change'] }],
        drivingLicense: [{ required: true, message: '请输入行驶证号', trigger: 'blur' }],
        vhcQuality: [{ required: true, message: '请输入总质量', trigger: 'blur' }],
        weight: [{ required: true, message: '请输入载重', trigger: 'blur' }],
        vhcVinNo: [{ required: true, message: '请输入车架号', trigger: 'blur' }],
        vhcEngineNo: [{ required: true, message: '请输入发动机号', trigger: 'blur' }],
        transportNo: [{ required: true, message: '请输入道路运输证号', trigger: 'blur' }],
        issueAuthority: [{ required: true, message: '请输入发证机关', trigger: 'blur' }],
        issueDate: [{ required: true, message: '请选择发证日期', trigger: ['blur', 'change'] }],
        registerDate: [{ required: true, message: '请选择注册日期', trigger: ['blur', 'change'] }]

      },
      dialogVisible: false,
      lookImgVisible: false,
      loading: 'false',
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      vehicleSSAdd: [
        {
          value: 1,
          label: '市场车辆',
          children: [
            {
              value: null,
              label: '请选择'
            },
            {
              value: 1,
              label: '单位'
            }, {
              value: 2,
              label: '个人'
            }]
        },
        {
          value: 2,
          label: '自家车辆'
        }
      ],
      NYtype: [],
      cllx: [
        { value: '', label: '请选择' },
        { value: 1, label: '集港' },
        { value: 2, label: '外发' }
      ],
      clys: [],
      ssdw: [],
      guanlianFlag: false,
      btnFlg: [],
      btnIdArr: ['00IP006B001', '00IM050100', '00IM050200', '00IM050300', '00IM050400']
    }
  },
  created () {
    this.tenantCode = localStorage.getItem('tenantCode')
    this.btnFlg = getBtn(this.btnIdArr, '/vehicleTowFleet')
    this.getList(this.searchFrom)
    cVLlist({}).then(res => {
      this.vehicleL = res
      this.vehicleL.unshift({ id: '', name: '请选择' })
    })
    cVTlist({}).then(res => {
      this.vehicleT = res
      // this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVPlist({}).then(res => {
      this.clyt = res
      this.clyt.unshift({ id: '', name: '请选择' })
    })
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
    cVhcEnergyTypeList({}).then(res => {
      this.NYtype = res
      this.NYtype.unshift({ id: '', energyName: '请选择' })
    })
    cVhcNoColourList({}).then(res => {
      this.clys = res
      this.clys.unshift({ id: '', colourName: '请选择' })
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    guanlianFn () {
      this.guanlianFlag = true
    },
    addVeicle () {
      this.dialogVisible = true
      this.isAdd = true
      this.row = {}
    },
    modifyVeicle (row) {
      this.row = row
      this.dialogVisible = true
      this.isAdd = false
    },
    Unconnect (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        fleetDelVehicle({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '解除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      fleetVehicleList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    vehicleSSAddChange (value) {

    },

    // 查看图片
    lookImg (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      if (row.vhcClassify == 1) {
        getStatementByVchId({ vhcId: row.id }).then(res => {
          this.lookImgVisible = true
          this.$set(this.addFrom, 'guaKaoUrl', res)
        })
      } else {
        this.lookImgVisible = true
      }
    },
    closeDialog () {
      this.addFrom = {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        guaKaoUrl: ''
      }
      this.vhcType = {}
      this.vhcL = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.imgfile = null
      this.imgfile = new FormData()
      this.newImgFlag = false
    },
    // 组件销毁
    destroy () {
      this.dialogVisible = false
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null,
        registerDate: null
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
.jiaoyan /deep/.el-date-editor {
    width: 150px!important;
}
/deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
}
.box{
  display: flex;
  flex-wrap: wrap;
  .imgBox{
    display: flex;
      margin-right:30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
.loogImgBox{
  display: flex;
  justify-content: space-around;
  .box1{
    width: 48%;
  }
  img{
    width: 100%;
  }
}

  /deep/.inpBox .bigInp .el-input__inner{
width: 250px;
}
.detailBox .el-form-item span{
  display:inline-block;
  width: 150px;
}
.detailBox img{
   width: 320px;
    height: 200px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;

}
/deep/.image-slot{
    height: 100%;
    background: #f3f1f1;
    font-size: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
